import React from 'react'
import { render } from 'react-dom'
import App from '../components/App'

const root = document.querySelector('#root')
render(<App />, root)



// WEBPACK FOOTER //
// ./src/client/index.js